export default {
    url: '',
    template: '<courses-courses-edit-occurrence-list course="vm.course"/>',
    controller (course) {
        this.course = course;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/list/index.js